import { createSelector, select } from '@ngrx/store';

import { StateSelector } from '@fcom/core/selectors/selector-utils';
import { FinnairPassengerItem } from '@fcom/dapi/api/models';
import { orderPassengersSelector } from '@fcom/common-booking/store/selectors/order.selector';

import { selectManageBookingState } from './feature.selector';
import { ManageBookingFeatureState, ManageBookingState } from '../../interfaces';

const getPassengersSelector = createSelector(
  selectManageBookingState,
  (state: ManageBookingState) => state.checkIn.passengers
);

export const selectedForCheckInPassengersSelector = createSelector(
  orderPassengersSelector,
  getPassengersSelector,
  (passengers, passengerIds): FinnairPassengerItem[] => passengers.filter(({ id }) => passengerIds.includes(id))
);

const getCheckInBoundIdSelector = createSelector(
  selectManageBookingState,
  (state: ManageBookingState) => state.checkIn.boundId
);

const getCheckInClearPendingSeatsOnEntrySelector = createSelector(
  selectManageBookingState,
  (state: ManageBookingState) => state.checkIn.clearPendingSeatsOnEntry
);

const getIsModifyCheckInSelector = createSelector(
  selectManageBookingState,
  (state: ManageBookingState) => state.checkIn.isModifyCheckIn
);

export const getPassengers = (): StateSelector<ManageBookingFeatureState, string[]> => select(getPassengersSelector);

export const getCheckInBoundId = (): StateSelector<ManageBookingFeatureState, string> =>
  select(getCheckInBoundIdSelector);

export const getCheckInClearPendingSeatsOnEntry = (): StateSelector<ManageBookingFeatureState, boolean> =>
  select(getCheckInClearPendingSeatsOnEntrySelector);

export const getIsModifyCheckIn = (): StateSelector<ManageBookingFeatureState, boolean> =>
  select(getIsModifyCheckInSelector);
